import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { formatStatus } from '../utils/formatStatus';
import ButtonRegular from './ui/ButtonRegular';
import '../styles/AdminOrderList.css';

function AdminOrderList() {
	const [monthsLoaded, setMonthsLoaded] = useState(0); // ile miesięcy wczytano
	const [ordersByMonth, setOrdersByMonth] = useState([]); // { monthLabel, orders }
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);

	const apiUrl = process.env.REACT_APP_API_URL || '';
	const navigate = useNavigate();

	const fetchMonth = async (monthsAgo) => {
		setLoading(true);
		try {
			const res = await axios.get(`${apiUrl}/api/orders/admin?monthsAgo=${monthsAgo}`, {
				headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
			});

			const orders = res.data.orders || [];

			const now = new Date();
			const target = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);
			const monthLabel = target.toLocaleString('default', { month: 'long', year: 'numeric' });

			setOrdersByMonth(prev => {
				if (prev.some(p => p.monthLabel === monthLabel)) return prev;
				return [...prev, { monthLabel, orders }];
			});

			if (monthsAgo >= 36) setHasMore(false); // ograniczenie do 3 lat
		} catch (err) {
			console.error('Błąd pobierania zamówień:', err);
			setHasMore(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchMonth(0);
		setMonthsLoaded(prev => prev === 0 ? 1 : prev);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleShowOlder = () => {
		if (loading) return;
		const next = monthsLoaded;
		fetchMonth(next);
		setMonthsLoaded(next + 1);
	};

	return (
		<div className="admin-orders admin-card">
			<h2>Zamówienia (panel admina)</h2>

			{ordersByMonth.map(section => (
				<section key={section.monthLabel} className="month-section">
					<h3 className="month-title">{section.monthLabel}</h3>
					{section.orders.length === 0 ? (
						<p className="no-orders">Brak zamówień w tym miesiącu.</p>
					) : (
						<div className="orders-list">
							{section.orders.map(order => (
								<div
									key={order._id}
									onClick={() => navigate(`/admin/orders/${order._id}`)}
									className="order-card"
								>
									<div className="order-info">
										{console.log(order)}
										<div><strong>Zamówienie:</strong> {order.orderNumber || order._id}</div>
										<div><strong>Klient:</strong> {order.clientAddress?.firstName || ''} {order.clientAddress?.lastName || ''}</div>
										<div><strong>Miasto:</strong> {order.shippingAddress?.city || ''}</div>
										<div><strong>Data:</strong> {order.createdAt ? new Date(order.createdAt).toLocaleString() : ''}</div>
									</div>
									<div className="order-right">
										<div><strong>Łącznie:</strong> {(order.total || 0).toFixed(2)} PLN</div>
										<div><strong>Status zamówienia:</strong> {formatStatus(order.status || 'pending')}</div>
										<div><strong>Status płatności:</strong> {formatStatus(order.payment.status || 'pending')}</div>
									</div>
								</div>
							))}
						</div>
					)}
				</section>
			))}

			<div className="orders-actions">
				{hasMore ? (
					<ButtonRegular onClick={handleShowOlder} disabled={loading}>
						{loading ? 'Ładowanie...' : 'Pokaż starsze zamówienia'}
					</ButtonRegular>
				) : (
					<p className="no-orders">Brak starszych zamówień do wyświetlenia.</p>
				)}
			</div>
		</div>
	);
}

export default AdminOrderList;
